// Vendors
import { StyledComponentsProvider } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
// Components
import { EntrypointComponent } from 'entrypoint/entrypoint.component';
// Contexts
import { AppInformationContextProvider } from 'contexts/app-information.context';
import { AppContextProvider } from 'contexts/app.context';
import { AuthContextProvider } from 'contexts/auth.context';
import { FeatureFlagsContextProvider } from 'contexts/feature-flags.context';
import { StylesContextProvider } from 'contexts/styles.context';
import { AppInformationProvider } from 'providers/app-information/app-information.provider';
import { BackgroundProvider } from 'providers/background/background.provider';
import { CheckoutProvider } from 'providers/checkout/checkout.provider';
import { ErrorProvider } from 'providers/error/error.provider';
import { FeatureFlagsProvider } from 'providers/feature-flags/feature-flags.provider';
import { InternationalizationProvider } from 'providers/internationalization/internationalization.provider';
import { SessionExpireProvider } from 'providers/session-expire/session-expire.provider';
import { TokenProvider } from 'providers/token/token.provider';
// Constants
import { THEME_PROVIDER_PROPS } from './constants/bootstrap.constants';

const Bootstrap = (): void => {
  localStorage.setItem('locale', 'es-ES');
  localStorage.setItem('language', 'es-ES');

  createRoot(document.getElementById('root') as HTMLElement).render(
    <StyledComponentsProvider {...THEME_PROVIDER_PROPS}>
      <ErrorBoundary FallbackComponent={() => null}>
        <AuthContextProvider>
          <AppInformationContextProvider>
            <InternationalizationProvider>
              <AppContextProvider>
                <StylesContextProvider>
                  <FeatureFlagsContextProvider>
                    <ErrorBoundary FallbackComponent={ErrorProvider}>
                      <BackgroundProvider>
                        <TokenProvider>
                          <FeatureFlagsProvider>
                            <SessionExpireProvider>
                              <CheckoutProvider>
                                <AppInformationProvider>
                                  <EntrypointComponent />
                                </AppInformationProvider>
                              </CheckoutProvider>
                            </SessionExpireProvider>
                          </FeatureFlagsProvider>
                        </TokenProvider>
                      </BackgroundProvider>
                    </ErrorBoundary>
                  </FeatureFlagsContextProvider>
                </StylesContextProvider>
              </AppContextProvider>
            </InternationalizationProvider>
          </AppInformationContextProvider>
        </AuthContextProvider>
      </ErrorBoundary>
    </StyledComponentsProvider>
  );
};

export { Bootstrap };
